import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import { useSiteSettings } from '../../context/SiteSettingsContext';
import ScheduleMeetPanel from './ScheduleMeetPanel';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [meetPanelOpen, setMeetPanelOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();
  const { loaded, visibleNavLinks, visibleCtaButtons } = useSiteSettings();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const handleCtaClick = (e, cta) => {
    if (cta.key === 'schedule-meet') {
      e.preventDefault();
      setMeetPanelOpen(true);
    }
  };

  // Don't render the navbar at all until settings have loaded — eliminates the flash
  if (!loaded) return null;

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`} id="main-navbar">
        <div className="navbar__container">
          <Link to="/" className="navbar__logo">
            <img src="/logo.webp" alt="Oko Solutions" className="navbar__logo-img" />
          </Link>

          <div className={`navbar__links ${isOpen ? 'navbar__links--open' : ''}`}>
            {visibleNavLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`navbar__link ${location.pathname === link.path ? 'navbar__link--active' : ''}`}
              >
                {link.label}
              </Link>
            ))}
            {user && (
              <>
                <Link to="/admin" className="navbar__link">Dashboard</Link>
                <button onClick={logout} className="navbar__link navbar__logout-btn">Logout</button>
              </>
            )}
            
            {/* Mobile CTA Buttons */}
            {visibleCtaButtons.length > 0 && (
              <div className="navbar__mobile-ctas">
                {visibleCtaButtons.map((cta) => (
                  <Link
                    key={cta.key || cta.label}
                    to={cta.path}
                    className={`navbar__mobile-cta ${cta.style === 'outline' ? 'navbar__mobile-cta--outline' : ''}`}
                    onClick={(e) => handleCtaClick(e, cta)}
                  >
                    {cta.label}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {visibleCtaButtons.length > 0 && (
            <div className="navbar__ctas">
              {visibleCtaButtons.map((cta) => (
                <Link
                  key={cta.key || cta.label}
                  to={cta.path}
                  className={`navbar__cta ${cta.style === 'outline' ? 'navbar__cta--outline' : ''}`}
                  onClick={(e) => handleCtaClick(e, cta)}
                >
                  {cta.label}
                </Link>
              ))}
            </div>
          )}

          <button
            className="navbar__toggle"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle navigation"
            id="nav-toggle"
          >
            {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </nav>

      <ScheduleMeetPanel
        isOpen={meetPanelOpen}
        onClose={() => setMeetPanelOpen(false)}
      />
    </>
  );
};

export default Navbar;
